import { Notify } from "Component/Notify";
import { useState, useEffect } from "react";
import CustomTable from "Component/CustomTable";
import React from "react";
import { fetchApi } from "Config/fetchApi";
import { TablePagination } from "@mui/material";
import { handleError, paginate } from "Helper";
import { DraggableModal } from "Component/Modal/index";
import Spinner from "Component/Spinner";

function OperationStatus() {
  // ==================== Pengaturan Modal ==================== //
  const [uuid, setUuid] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [flagModal, setFlagModal] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [statusOperasi, setStatusOperasi] = useState("");
  const [kodeStatusOperasi, setKodeStatusOperasi] = useState("");
  const [statusData, setStatusData] = useState("");
  // ==================== Pengaturan Modal ==================== //

  const [keywordSearch, setDataKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [headerTable] = useState([
    {
      label: "Status Operasi Kepolisian",
      key: "operation_status_name",
      align: "center",
    },
    {
      label: "Kode Status Operasi",
      key: "operation_status_code",
      align: "center",
    },
    {
      label: "Status Data",
      key: "flag_active_operation_status",
      align: "center",
    },
  ]);
  const [isActionTable] = useState({
    isAdd: true,
    isEdit: true,
    isShow: false,
    isDelete: false,
  });

  // ==================== Pengaturan Pagination ==================== //
  const [dataPaginate, setDataPaginate] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
    if (keywordSearch === "") {
      setDataPaginate(paginate(dataOriginal, newPage, pageSize));
    } else {
      const filteredData = dataOriginal?.filter((item) => {
        const lowerCasedSearchText = keywordSearch.toLowerCase();
        return item?.flag_active_operation_status
          .toLowerCase()
          .includes(lowerCasedSearchText);
      });
      setDataPaginate(paginate(filteredData, newPage, pageSize));
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    if (keywordSearch === "") {
      setDataPaginate(
        paginate(dataOriginal, pageNumber, parseInt(event.target.value, 10))
      );
    } else {
      const filteredData = dataOriginal?.filter((item) => {
        const lowerCasedSearchText = keywordSearch.toLowerCase();
        return item?.flag_active_operation_status
          .toLowerCase()
          .includes(lowerCasedSearchText);
      });
      setDataPaginate(
        paginate(filteredData, pageNumber, parseInt(event.target.value, 10))
      );
    }
  };
  // ==================== Pengaturan Pagination ==================== //

  // ==================== Default ==================== //
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().get(`/operation-status/get-list`);
      const updatedData = response.data?.data.map((item) => ({
        ...item,
        flag_active_operation_status: item.flag_active_operation_status
          ? "Aktif"
          : "Non-Aktif",
      }));
      setDataOriginal(updatedData);
      setDataPaginate(paginate(updatedData, pageNumber, pageSize));
      setIsLoading(false);
    } catch (err) {
      setDataOriginal([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const createData = async () => {
    try {
      setIsLoadingModal(true);
      const response = await fetchApi().post(`/operation-status/create`, {
        operation_status_name: statusOperasi,
        operation_status_code: kodeStatusOperasi,
        flag_active_operation: statusData === "Aktif" ? true : false,
      });
      handleSuccess(response.data?.message);
      setIsLoadingModal(false);

      // Reset Data
      setOpenModal(false);
      getData();
    } catch (err) {
      setIsLoadingModal(false);
      handleError(err);
    }
  };
  const updateData = async () => {
    try {
      setIsLoadingModal(true);
      const response = await fetchApi().put(
        `/operation-status/update/${uuid}`,
        {
          operation_status_name: statusOperasi,
          operation_status_code: kodeStatusOperasi,
          flag_active_operation: statusData === "Aktif" ? true : false,
        }
      );
      handleSuccess(response.data?.message);
      setIsLoadingModal(false);

      // Reset Data
      setOpenModal(false);
      getData();
    } catch (err) {
      setIsLoadingModal(false);
      handleError(err);
    }
  };
  const onSearchData = async (keyword) => {
    setDataKeyword(keyword);
    if (keyword.trim() === "") {
      getData();
    } else {
      const filteredData = dataOriginal?.filter((item) => {
        const lowerCasedSearchText = keyword.toLowerCase();
        return item?.operation_status_name
          .toLowerCase()
          .includes(lowerCasedSearchText);
      });

      setDataPaginate(paginate(filteredData, pageNumber, pageSize));
    }
  };
  const handleSubmitForm = async (e) => {
    e.preventDefault();
    if (flagModal === "Add") {
      createData();
    } else {
      updateData();
    }
  };
  useEffect(() => {
    getData();
  }, []);
  // ==================== Default ==================== //

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Master Data Status Operasi Kepolisian
        </p>
      </div>
      <CustomTable
        onClickCreate={() => {
          setFlagModal("Add");
          setOpenModal(true);
          setUuid("");
          setStatusOperasi("");
          setKodeStatusOperasi("");
          setStatusData("");
        }}
        isAction={isActionTable}
        onEditData={(data) => {
          setFlagModal("Edit");
          setOpenModal(true);
          setUuid(data?.id || "");
          setStatusOperasi(data?.operation_status_name || "");
          setKodeStatusOperasi(data?.operation_status_code || "");
          setStatusData(data?.flag_active_operation_status || "");
        }}
        isLoading={isLoading}
        headerData={headerTable}
        Data={dataPaginate}
        onSearchData={onSearchData}
        TablePagination={
          <TablePagination
            rowsPerPageOptions={[15, 20, 30, 50]}
            component="div"
            count={dataOriginal.length}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
      />
      {/* Modal Add Data */}
      <DraggableModal size="sm" open={openModal} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              {flagModal === "Add"
                ? "Tambah Data Baru"
                : flagModal === "Edit"
                  ? "Ubah Data"
                  : ""}
            </p>
            <button
              disabled={isLoadingModal}
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModal(!openModal)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>
        <form className="space-y-5" onSubmit={handleSubmitForm}>
          <DraggableModal.Body>
            <div className="mb-2">
              <label
                htmlFor="status_operasi"
                className="flex block text-sm font-medium leading-6"
              >
                Status Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="status_operasi"
                  name="status_operasi"
                  disabled={isLoadingModal}
                  type="text"
                  value={statusOperasi}
                  placeholder="Masukkan Status Operasi"
                  onChange={(e) => setStatusOperasi(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2">
              <label
                htmlFor="kode_status_operasi"
                className="flex block text-sm font-medium leading-6"
              >
                Kode Status Operasi
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="kode_status_operasi"
                  disabled={isLoadingModal}
                  name="kode_status_operasi"
                  type="text"
                  value={kodeStatusOperasi}
                  placeholder="Masukkan Kode Status Operasi"
                  onChange={(e) => setKodeStatusOperasi(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="status_data"
                className="flex block text-sm font-medium leading-6"
              >
                Status Data
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="status_data"
                    name="status_data"
                    value={statusData}
                    disabled={isLoadingModal}
                    required
                    onChange={(e) => {
                      setStatusData(e.target.value);
                    }}
                    className="h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none"
                  >
                    <option value="" disabled selected hidden>
                      Pilih Status Data
                    </option>
                    <option value="Aktif">Aktif</option>
                    <option value="Non-Aktif">Non-Aktif</option>
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </DraggableModal.Body>
          <DraggableModal.Footer>
            <div className="flex gap-4 items-center justify-end">
              <button
                disabled={isLoadingModal}
                className="h-11 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-sm font-semibold leading-6 text-black  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                onClick={() => setOpenModal(!openModal)}
              >
                Tutup
              </button>
              <button
                disabled={isLoadingModal}
                className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                Simpan
                {isLoadingModal ? <Spinner classAddition={"ml-3 w-6"} /> : null}
              </button>
            </div>
          </DraggableModal.Footer>
        </form>
      </DraggableModal>
    </div>
  );
}

export default OperationStatus;
